import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import CustomMorePopover from '@/components/global/buttons/CustomMorePopover';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import CustomShowModalButton from '@/components/global/buttons/CustomShowModalButton.jsx';
import { useDrawer } from '@/composables/useDrawer';
import { roleIsClient } from '@/constants/Roles.js';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';
import { ResendInviteButton, ResetPasswordButton } from '@/components/global/buttons/actionButtons.jsx';

export const UserMoreActions = ({ permissions, record, buttonLabel, className = '', color = 'primary', includeShow = true }) => {
    const { openDrawer } = useDrawer();
    const translate = useTranslate();

    if (!record) return null;

    const canShow = includeShow && canViewDetails('user', permissions);
    const canEdit = !permissions.isBok || roleIsClient(record.role);
    const canResetOrInvite = permissions.isAdmin;

    if (!canShow && !canEdit && !canResetOrInvite) {
        return null;
    }

    return (
        <CustomMorePopover permissions={permissions} record={record} buttonLabel={buttonLabel} className={className} color={color}>
            {canShow && <CustomShowModalButton label={translate('resources.user.labels.showUser')} onOpen={() => openDrawer(record.id, 'user-show')} />}
            {canEdit && <CustomEditModalButton onOpen={() => openDrawer(record.id, 'user-edit')} label={translate('resources.user.labels.editSettings')} />}
            {canResetOrInvite && (
                <>
                    <ResetPasswordButton
                        id={record.id}
                        label={translate('resources.user.labels.resetPassword')}
                        disabled={!record.isActive}
                        buttonProps={{ 'data-keep-popover-open': true }}
                    />
                    <ResendInviteButton
                        id={record.id}
                        label={translate('resources.user.labels.resendInvite')}
                        disabled={record.isActive}
                        buttonProps={{ 'data-keep-popover-open': true }}
                    />
                </>
            )}
        </CustomMorePopover>
    );
};

UserMoreActions.propTypes = {
    permissions: PropTypes.shape({
        isBok: PropTypes.bool,
        isAdmin: PropTypes.bool,
        isClientMaster: PropTypes.bool,
        isServiceMaster: PropTypes.bool,
    }).isRequired,
    record: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        role: PropTypes.string,
        isActive: PropTypes.bool,
    }),
    buttonLabel: PropTypes.string,
    className: PropTypes.string,
    color: PropTypes.string,
    includeShow: PropTypes.bool,
};
